/* lystia-carousel.js - <lystia-carousel class="carousel" [data-dots] [data-arrows]> (parity/snippets.md §10).
   Всередині: .carousel__track зі слайдами-дітьми. Підписи (з locales у розмітці):
   data-label-prev, data-label-next, data-label-slide (з "{n}"). API: go(i), next(), prev(), index(). */
(function () {
  'use strict';
  if (customElements.get('lystia-carousel')) return;

  var SVG_NS = 'http://www.w3.org/2000/svg';

  function chevron(d) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'ico');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var p = document.createElementNS(SVG_NS, 'path');
    p.setAttribute('d', d);
    svg.appendChild(p);
    return svg;
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  class LystiaCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.carousel__track');
      if (!this.track) return;
      this.dots = null;
      this.prevBtn = null;
      this.nextBtn = null;
      if (this.hasAttribute('data-dots')) this._buildDots();
      if (this.hasAttribute('data-arrows')) this._buildArrows();
      this._update = this._update.bind(this);
      this._onScroll = debounce(this._update, 60);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      requestAnimationFrame(this._update);
    }

    disconnectedCallback() {
      if (this.track && this._onScroll) this.track.removeEventListener('scroll', this._onScroll);
    }

    _slides() { return Array.prototype.slice.call(this.track.children); }

    _padLeft() { return parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0; }

    index() {
      var x = this.track.scrollLeft;
      var pad = this._padLeft();
      var best = 0;
      var bd = Infinity;
      this._slides().forEach((c, i) => {
        var d = Math.abs(c.offsetLeft - this.track.offsetLeft - x - pad);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }

    go(i) {
      var s = this._slides();
      i = Math.max(0, Math.min(s.length - 1, i));
      var c = s[i];
      if (!c) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: c.offsetLeft - this.track.offsetLeft - this._padLeft(), behavior: reduced ? 'auto' : 'smooth' });
    }

    next() { this.go(this.index() + 1); }

    prev() { this.go(this.index() - 1); }

    _buildDots() {
      var label = this.getAttribute('data-label-slide') || '{n}';
      this.dots = document.createElement('div');
      this.dots.className = 'carousel__dots';
      this.dots.setAttribute('role', 'tablist');
      this._slides().forEach((_, i) => {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'carousel__dot';
        b.setAttribute('aria-label', label.replace('{n}', i + 1));
        b.addEventListener('click', () => this.go(i));
        this.dots.appendChild(b);
      });
      this.appendChild(this.dots);
    }

    _buildArrows() {
      this.prevBtn = this._arrow('prev', this.getAttribute('data-label-prev') || '', 'M15 6L9 12L15 18', () => this.go(this.index() - 1));
      this.nextBtn = this._arrow('next', this.getAttribute('data-label-next') || '', 'M9 6L15 12L9 18', () => this.go(this.index() + 1));
      this.append(this.prevBtn, this.nextBtn);
    }

    _arrow(dir, label, d, fn) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'carousel__arrow carousel__arrow--' + dir;
      b.setAttribute('aria-label', label);
      b.appendChild(chevron(d));
      b.addEventListener('click', fn);
      return b;
    }

    _update() {
      var t = this.track;
      var i = this.index();
      var n = this._slides().length;
      if (this.dots) {
        Array.prototype.forEach.call(this.dots.children, (d, k) => {
          var on = k === i;
          d.classList.toggle('is-active', on);
          if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
      if (this.prevBtn) this.prevBtn.disabled = t.scrollLeft <= 2;
      if (this.nextBtn) this.nextBtn.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2 || i >= n - 1;
    }
  }

  customElements.define('lystia-carousel', LystiaCarousel);
})();
